import React, {useState,useEffect} from "react";
import { useHistory } from "react-router-dom";
import {motion} from "framer-motion";
import {useSelector,useDispatch} from 'react-redux'
import {setSkills} from '../actions'
import Skill from './Skill'
import {skillSet} from '../ExData'
import GeneralModal from './GeneralModal'

const contVariant={
  hidden:{
    x:"100vw"
  },
  visible:{
    x:0,
    transition:{
      delay:0.1,
      type:"spring",
      stiffness:80,
      mass:0.4,
      damping:8
    }
  }
}
const linkVariant={
  hover:{
    textShadow: "2px 2px 10px rgba(0,0,0,0.8)",
    boxShadow:"2px 2px 10px rgba(0,0,0,0.8)",
    transition:{
      duration:0.2
    }
  }
}
export default function Skills() {
  const resumeSkills=useSelector(states=>states.resumeData).skills
  const dispatch=useDispatch()
  const history = useHistory();
  const [prof,setProf]=useState("50")
  const [wantProf,setWantProf]=useState(true)
  const exSkills=skillSet
  const [skills,setResumeSkills]=useState(()=>{
    return resumeSkills
  })
  const [skillValue,setSkillValue]=useState('')
  function handleSubmit(e) {
    e.preventDefault();
    dispatch(setSkills(skills))
    history.push("/add-languages");
  }
  function addSkill(e){
    e.preventDefault();
    let skill={
                skill:skillValue,
                prof: wantProf ? prof : ""
              }
    setResumeSkills((prevSkills)=>{
      if(prevSkills.find((skill)=>{ return skill.skill===skillValue}))
        return prevSkills
      return [...prevSkills,{...skill}]
    })
  }
  function removeSkill(id){
    setResumeSkills((prevSkills)=>{
      return prevSkills.filter((skill,index)=>index!==id)
    })
  }
  function chooseRandomSkill(){
    let index=Math.floor(Math.random()*exSkills[0].softSkills.length)
    let choosenSkill=exSkills[0].softSkills[index]
    setSkillValue(choosenSkill)
  }
  const [showModal,setShowModal]=useState(false)
  useEffect(()=>{
    setSkillValue('')
    setProf("75")
  },[skills])
  return (
    <>
    <GeneralModal showModal={showModal} setShowModal={setShowModal}>
        <h4 className="mt-4 text-primary"><strong>Sample Skills</strong></h4>
        <p>you can refer the following skill set samples</p>
        <div className="sample-intro">
          <div className="sample-box" style={{paddingTop:0}}>
            <h6><strong>Soft skills</strong></h6>
            <ul>
              {exSkills[0].softSkills.map((skill,index)=>(
                <li key={index}>{skill}</li>
              ))}
            </ul>
          </div>
          <div className="sample-box" style={{paddingTop:0}}>
            <h6><strong>Programming languages</strong></h6>
            <ul>
              {exSkills[1].hardSkills.engineering.languages.map((skill,index)=>(
                <li key={index}>{skill}</li>
              ))}
            </ul>
          </div>    
          <div className="sample-box" style={{paddingTop:0}}>
            <h6><strong>Engineering (General)</strong></h6>
            <ul>
              {exSkills[1].hardSkills.engineering.general.map((skill,index)=>(
                <li key={index}>{skill}</li>
              ))}
            </ul>
          </div>   
          <div className="sample-box" style={{paddingTop:0}}>
            <h6><strong>Management</strong></h6>
            <ul>
              {exSkills[2].management.map((skill,index)=>(
                <li key={index}>{skill}</li>
              ))}
            </ul>
          </div>  
          <div className="sample-box" style={{paddingTop:0}}>
            <h6><strong>Medical</strong></h6>
            <ul>
              {exSkills[3].medical.map((skill,index)=>(
                <li key={index}>{skill}</li>
              ))}
            </ul>
          </div>  
        </div>
        <small>simply search your relevant skills and add to your resume.</small>
    </GeneralModal>
    <motion.div className="container" exit={{x:"-100vw"}}>
      <motion.div className="form"
        variants={contVariant}
        initial="hidden"
        animate="visible"
      >
        <div><h1><i class="mr-2 fas fa-code"></i>Skills</h1>
        <button className="text-light my-2 py-2 b-1 random-btn" onClick={chooseRandomSkill}>choose random</button>
        <button className="text-light my-2 py-2 b-1 random-btn" onClick={()=>setShowModal(true)}>refer sample</button>
        </div>
        <form onSubmit={addSkill}>
          <div className="input-btn">
            <input type="text" value={skillValue} onChange={(e)=>setSkillValue(e.target.value)} placeholder="add skill then press enter" required />
            <span className="pb-1 mb-2"><button type="submit"><i class="fas fa-plus"></i></button></span>
          </div><br/>
          {wantProf && (<><label>Proficiency : {prof}%</label>
          <input type="range" value={prof} onChange={(e)=>setProf(e.target.value)} required/>
          </>)}
          <div><span data-tooltip="It is recommended that either you should have 'proficiency %' for every skill or for no skill at all for better resume look." className="normal-link" onClick={()=>setWantProf(prevProf=>!prevProf)}>{wantProf ? 'remove' : 'add'} proficiency ?</span></div>
        </form>
        <ul>
          {skills.map((skill,index)=>{
            return (<Skill skill={skill} key={index} id={index} removeSkill={removeSkill} />)
          })}
        </ul>
        {skills!=0 && <motion.button variants={linkVariant} whileHover="hover" className="save-btn" onClick={handleSubmit}>save & next</motion.button>}
      </motion.div>
    </motion.div>
  </>
  );
}
